module.exports = __webpack_public_path__ + "img/bell.464ed045.svg";